import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";

import { AccountService } from "../services/account-service";
import { AclService } from "../services/acl-service";
import { foreachGraph } from "lodash";



    CharDataGroupCharsFilter.$inject = ['accountService', '$filter'];
export function CharDataGroupCharsFilter(accountService: AccountService, $filter: ng.IFilterService) {
        return (charData: Models.ICharDataCollection, params: { groupId: number; visibility: number; tagLabels?: string[] }) => {
            if (charData == undefined || !charData.templateMetaData) {
                return [];
            }

            // this normalizes characteristics across multiple templates 
            if (params.tagLabels) {
                var missingTagLabels: string[] = [];
                var charID = -1;
                params.tagLabels.forEach((tagLabel) => {
                    var hasTagLabel = false;
                    for (var i = 0; i < charData.templateMetaData.characteristicMetaDatas.length; i++) {
                        var cmd = charData.templateMetaData.characteristicMetaDatas[i];
                        if (cmd.tagLabel === tagLabel) {
                            hasTagLabel = true;
                            break;
                        }
                    }

                    if (!hasTagLabel) {
                        charData.templateMetaData.characteristicMetaDatas.push({
                            groupID: 1,
                            tagLabel: tagLabel,
                            sequenceNumber: -1,
                            requiredIndicator: -1,                            
                            charValueSourceID: '',                            
                            charTypeID: charData.templateMetaData.charTypeID,
                            characteristicID: charID--,
                            label: tagLabel[0].toUpperCase() + tagLabel.substr(1, tagLabel.length),
                            maxLength: 0,
                            dataTypeID: Consts.CharDataTypeIDs.CharDataTypes.alphanumeric,
                            systemIndicator: 0,
                            multipleIndicator: -1,
                            charValueSetID: '',
                            acl: "",
							reportIndicator: null,
                            description: "",
                            triggerTypeID: null,
                            triggerCharID: null,
                            triggerValue: null
                        });

                        charData.charDatas[tagLabel] = [];
                        charData.charDatas[tagLabel].push({
                            charID: charID,
                            recCharID: -1,
                            value: ''
                        });
                    }
                });
            }

            return $filter<IMetaDataFilter>('metaData')(charData.templateMetaData, { groupId: params.groupId, visibility: params.visibility, tagLabels: params.tagLabels });
        };
    }

    export interface IMetaDataFilter {
        (metaData: Models.ICharacteristicMetaDataCollection, params: { groupId: number; visibility: number; tagLabels?: string[] }): Models.ICharacteristicMetaData[];
    }

    MetaDataFilter.$inject = ["aclService"];
export function MetaDataFilter(aclService: AclService) {
        return (metaData: Models.ICharacteristicMetaDataCollection, params: { groupId: number; visibility: number; tagLabels?: string[] }) => {
            if (metaData == undefined) {
                return [];
            }

            var unsortedColumns = _(Utils.AclUtil.filterCMDsByRights(aclService.acls, metaData, Consts.AccessRight.Read))
                .filter((cmd) => { return !params.tagLabels || params.tagLabels.indexOf(cmd.tagLabel) > -1 })
                .filter((cmd) => { return (cmd.groupID == params.groupId || params.groupId == -1) })
                .valueOf();

            var groups: Models.ITemplateCharacteristicGroup[] = [];
            groups = _.sortBy(metaData.groups, g => g.sequenceNumber);
            var sortedColumns: Models.ICharacteristicMetaData[] = [];
            groups.forEach((group) => {
                var groupCmds = unsortedColumns.filter(cmd => cmd.groupID == group.groupID);
                groupCmds = _.sortBy(groupCmds, cmd => cmd.sequenceNumber);
                sortedColumns = sortedColumns.concat(groupCmds);
            });
            return sortedColumns;
        }
	}

	export function DisplayTextFilter() {
		return (charDataValue) => {						
			// http://, https://, ftp://
			var urlPattern = /\b(?:https?|ftp):\/\/[a-z0-9-+&@#\/%?=~_|!:,.;]*[a-z0-9-+&@#\/%=~_|]/gim;

			// www. sans http:// or https://
			var pseudoUrlPattern = /(^|[^\/])(www\.[\S]+(\b|$))/gim;

		    if (!charDataValue) return "";

			return charDataValue
				.replace(urlPattern, '<a href="$&" target="_blank">$& <i class="fa fa-external-link"></i></a>')
				.replace(pseudoUrlPattern, '$1<a href="http://$2" target="_blank">$2 <i class="fa fa-external-link"></i></a>');			
		};
	}
